<template>
<span>
  <v-text-field
    v-money="currency"
    v-model="modelStart"
    prefix="Од"
    :disabled="disabled"
    @keyup="onInput"
    color="teal lighten-2"
    :readonly="readonly"
    hide-details/>
  <v-text-field
    v-money="currency"
    v-model="modelEnd"
    prefix="До"
    @keyup="onInput"
    :disabled="disabled"
    color="teal lighten-2"
    :readonly="readonly"
    hide-details/>
</span>
</template>
<script>
import { VMoney } from 'v-money'

export default {
  name: 'money-range',
  directives: { money: VMoney },
  data () {
    return {
      modelStart: '',
      modelEnd: '',
      currency: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  methods: {
    onInput () {
      this.$emit('input', [this.modelStart !== '0,00' ? this.flattenDecimal(this.modelStart) : '', this.modelEnd !== '0,00' ? this.flattenDecimal(this.modelEnd) : ''])
    },
    flattenDecimal (decimal) {
      const commaIndex = decimal.indexOf(',')
      const dotIndex = decimal.indexOf('.')
      if (commaIndex >= 0 && dotIndex >= 0) {
        return decimal.replace(/\./g, '').replace(',', '.')
      } else if (commaIndex >= 0) {
        return decimal.replace(',', '.')
      }
      return decimal
    }
  },
  props: {
    value: {},
    label: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
